import PropTypes from 'prop-types'
import {
  Table, Select, Button, Input, DatePicker, Tag,
} from 'antd'
import moment from 'moment'
import CoreApiLogDetailModal from './DetailModal'

const CoreApiLogList = ({
  dataCoreApiLog, metaCoreApiLog, isFetching,
  isFetchingDetail, detailCoreApiLog, detailVisible,
  handlePage, handleFilter, handleChangeDate,
  handleOpenDetail, handleCloseDetail,
  limitList, statusList, serviceList, apiNames,
}) => {
  const columns = [
    {
      title: 'No',
      dataIndex: '',
      key: 'No',
      width: 60,
      render: (text, record, index) => (metaCoreApiLog.per_page * (metaCoreApiLog.current_page - 1)) + index + 1,
    },
    {
      title: 'Tanggal',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 170,
      render: text => (text ? moment(text).format('DD MMM YYYY HH:mm:ss') : '-'),
    },
    {
      title: 'API',
      dataIndex: 'api_name',
      key: 'api_name',
      render: text => text || '-',
    },
    {
      title: 'Method',
      dataIndex: 'method',
      key: 'method',
      width: 80,
      render: text => text || '-',
    },
    {
      title: 'Referensi',
      dataIndex: 'reference',
      key: 'reference',
      render: text => text || '-',
    },
    {
      title: 'Service',
      dataIndex: 'service',
      key: 'service',
      width: 100,
      render: text => (text ? <Tag>{text}</Tag> : '-'),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (text) => {
        if (text === 'success') return <Tag color="green">success</Tag>
        if (text === 'failed') return <Tag color="red">failed</Tag>
        return '-'
      },
    },
    {
      title: 'Durasi',
      dataIndex: 'duration_ms',
      key: 'duration_ms',
      width: 90,
      render: text => (text !== undefined && text !== null ? `${text} ms` : '-'),
    },
    {
      title: 'Pesan',
      dataIndex: 'error_message',
      key: 'error_message',
      ellipsis: true,
      render: text => text || '-',
    },
    {
      title: 'Aksi',
      dataIndex: '',
      key: 'action',
      width: 90,
      render: (text, record) => (
        <Button size="small" onClick={() => handleOpenDetail(record.id)}>Detail</Button>
      ),
    },
  ]

  return (
    <div>
      <div className="pb-3 d-flex justify-content-between">
        <div className="d-flex flex-wrap justify-content-start align-items-center btn-primary-wrapper">
          <div className="d-flex mr-2">
            <h6 className="mb-1 mr-2 align-self-center">Filter By: </h6>
            <Select
              placeholder="Limit"
              style={{ width: 100 }}
              onChange={val => handleFilter('limit', val)}
              className="mr-2"
            >
              {limitList.map(item => <Select.Option key={item.id} value={item.label}>{item.label}</Select.Option>)}
            </Select>
          </div>
          <div className="mr-3">
            <Select
              allowClear
              showSearch
              placeholder="API"
              style={{ width: 240 }}
              onChange={val => handleFilter('apiName', val)}
            >
              {apiNames.map(name => <Select.Option key={name} value={name}>{name}</Select.Option>)}
            </Select>
          </div>
          <div className="mr-3">
            <Select
              allowClear
              placeholder="Status"
              style={{ width: 120 }}
              onChange={val => handleFilter('status', val)}
            >
              {statusList.map(item => <Select.Option key={item.id} value={item.label}>{item.label}</Select.Option>)}
            </Select>
          </div>
          <div className="mr-3">
            <Select
              allowClear
              placeholder="Service"
              style={{ width: 120 }}
              onChange={val => handleFilter('service', val)}
            >
              {serviceList.map(item => <Select.Option key={item.id} value={item.label}>{item.label}</Select.Option>)}
            </Select>
          </div>
          <div className="mr-3">
            <DatePicker.RangePicker
              format="YYYY-MM-DD"
              placeholder={['Start Date', 'End Date']}
              onChange={handleChangeDate}
            />
          </div>
          <div className="mr-3">
            <Input.Search
              allowClear
              placeholder="Cari API / No. Peserta / pesan"
              onSearch={val => handleFilter('search', val)}
              enterButton
            />
          </div>
        </div>
      </div>
      <Table
        rowKey="id"
        className="table-striped-rows"
        loading={isFetching}
        columns={columns}
        dataSource={dataCoreApiLog}
        pagination={{
          showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
          pageSize: metaCoreApiLog ? metaCoreApiLog.per_page : 10,
          total: metaCoreApiLog ? metaCoreApiLog.total_count : dataCoreApiLog.length,
          current: metaCoreApiLog ? metaCoreApiLog.current_page : 1,
          onChange: handlePage,
        }}
      />
      <CoreApiLogDetailModal
        visible={detailVisible}
        loading={isFetchingDetail}
        data={detailCoreApiLog}
        onClose={handleCloseDetail}
      />
    </div>
  )
}

CoreApiLogList.propTypes = {
  dataCoreApiLog: PropTypes.array,
  metaCoreApiLog: PropTypes.object,
  isFetching: PropTypes.bool,
  isFetchingDetail: PropTypes.bool,
  detailCoreApiLog: PropTypes.object,
  detailVisible: PropTypes.bool,
  handlePage: PropTypes.func,
  handleFilter: PropTypes.func,
  handleChangeDate: PropTypes.func,
  handleOpenDetail: PropTypes.func,
  handleCloseDetail: PropTypes.func,
  limitList: PropTypes.array,
  statusList: PropTypes.array,
  serviceList: PropTypes.array,
  apiNames: PropTypes.array,
}

export default CoreApiLogList
